import controller from './search.controller';

const template = require('./search.html');

export default {
    bindings: {
        query: '<',
        onFocusChange: '&',
        onSearchResult: '&',
        onBeforeSearch: '&',
        onEmptySearch: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/simple/search.component.js